import { useReducer, useState } from "react";
import { vspPortalReducer } from "./vspPortalReducer";
import VspPortalContext from "./VspPortalContext";
import { initialVspPortalState } from "./VspPortalState";


type VspPortalProviderProviderProps = { children: React.ReactNode };


const VspPortalProvider = ( { children } : VspPortalProviderProviderProps ) => {

  const [ state, dispatch ] = useReducer( vspPortalReducer, initialVspPortalState );

  return (
      <VspPortalContext.Provider value={{ state, dispatch }}>
        {children}
      </VspPortalContext.Provider>
    );

}

export default VspPortalProvider;